import { useState, useEffect } from "react";
import { FaLock, FaEye, FaEyeSlash, FaTimes, FaShieldAlt } from "react-icons/fa";

export default function ChangePasswordPanel({ isOpen, onClose }) {
  const [show, setShow] = useState({});
  const [input, setInput] = useState({ current: "", newPass: "", confirm: "" });
  const [errors, setErrors] = useState({});

  const changeField = (k, v) => setInput({ ...input, [k]: v });

  const validate = () => {
    let err = {};

    // ⭐ FETCH REAL SAVED PASSWORD
    const savedUser = JSON.parse(localStorage.getItem("registeredUser"));
    const realPassword = savedUser?.password || "";

    // ⭐ CHECK CURRENT PASSWORD AGAINST REAL PASSWORD
    if (!input.current) err.current = "Current password required";
    else if (input.current !== realPassword)
      err.current = "Incorrect current password";

    // NEW PASSWORD RULES
    if (!input.newPass || input.newPass.length < 6)
      err.newPass = "Minimum 6 characters";

    if (input.newPass === input.current)
      err.newPass = "Must not match current password";

    // CONFIRM MATCH
    if (input.confirm !== input.newPass)
      err.confirm = "Passwords do not match";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ⭐ PREVENT BACKGROUND SCROLL
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"></div>
      )}

      {/* MODAL */}
      <div
        className={`
          fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          w-full max-w-[380px] bg-[#FFF4E6]
          rounded-xl border border-orange-300 shadow-xl p-4 z-50
          transition-all duration-300 max-h-[80vh] overflow-y-auto
          ${isOpen ? "opacity-100 scale-100" : "opacity-0 scale-90 pointer-events-none"}
        `}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center pb-4 border-b">
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <FaShieldAlt className="text-blue-600" />
            Change Password
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-800">
            <FaTimes size={18} />
          </button>
        </div>

        {/* INPUTS */}
        <div className="space-y-4 mt-4">
          {["current", "newPass", "confirm"].map((field) => (
            <div key={field}>
              <label className="text-sm font-semibold text-gray-800">
                {field === "current"
                  ? "Current Password *"
                  : field === "newPass"
                  ? "New Password *"
                  : "Confirm Password *"}
              </label>

              <div className="relative mt-1">
                <input
                  type={show[field] ? "text" : "password"}
                  className={`w-full p-3 pl-10 pr-10 bg-white border rounded-lg shadow-sm ${
                    errors[field] ? "border-red-500 bg-red-50" : "border-gray-300"
                  }`}
                  value={input[field]}
                  onChange={(e) => changeField(field, e.target.value)}
                />

                <FaLock className="absolute left-3 top-3.5 text-gray-500" />

                <span
                  className="absolute right-3 top-3.5 cursor-pointer"
                  onClick={() => setShow({ ...show, [field]: !show[field] })}
                >
                  {show[field] ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {errors[field] && (
                <p className="text-xs text-red-500 mt-1">{errors[field]}</p>
              )}
            </div>
          ))}

          {/* RULES */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm">
            <p className="text-blue-700 font-medium mb-1">Password rules:</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Minimum 6 characters</li>
              <li>Must not match current password</li>
              <li>Both fields must match</li>
            </ul>
          </div>
        </div>

        {/* BUTTONS */}
        <div className="pt-6 mt-6 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 border rounded-lg bg-gray-100"
          >
            Cancel
          </button>

          {/* ⭐ FINAL WORKING UPDATE BUTTON */}
          <button
            onClick={() => {
              if (!validate()) return;

              const savedUser = JSON.parse(localStorage.getItem("registeredUser"));

              const updatedUser = {
                ...savedUser,
                password: input.newPass, // ⭐ SAVE NEW PASSWORD
              };

              localStorage.setItem("registeredUser", JSON.stringify(updatedUser));

              onClose();
            }}
            className="px-6 py-2 text-white rounded-lg bg-gradient-to-r from-orange-500 to-red-600"
          >
            Update
          </button>
        </div>
      </div>
    </>
  );
}

 